import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Input, SnackbarContent, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import * as api from '../api/calls'
import { ServerSettingsTable, AccountInfoTable } from './Tables/table'
import { ManageServersTable } from './Tables/ManageServersTable';
import AlertSure from './Alert'
import Snackbar from '@material-ui/core/Snackbar';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Link, navigate } from 'gatsby'
import StripeManage from './StripeManage'
import RefreshIcon from '@material-ui/icons/Refresh';

const useStyles = makeStyles((theme) => ({
    alertSuccess: {
        backgroundColor: 'rgba(0,100,0,0.5)',
        color: 'white'
    },
    alertError: {
        backgroundColor: 'rgba(100,0,0,0.5)',
        color: 'white'
    },
    headerButtons: {
        "& > * ": {
            maxWidth: '30vw',
        },
        display: 'flex',
        justifyContent: 'space-evenly',

    },
    dialog: {
        padding: '3rem'
    },
    spaced: {
        justifyContent: 'space-evenly',
        textAlign: 'center'
    },
    descTxt: {
        fontFamily: 'Roboto',
        '& a': {
            color: 'blue'
        }

    }
}))


function AccountManager({ myServers, setMyServers, userDetails }) {

    const classes = useStyles()
    return (
        <Box>
            {userDetails ?
                <Box>

                    <Box className={classes.headerButtons} display="flex" justifyContent="space-evenly">
                        <Logout />
                        <Link to="/buy">
                            <Button variant="contained" color="secondary">Buy Server</Button>
                        </Link>
                        <StripeManage userDetails={userDetails} />
                    </Box>

                    <AccountInfoTable userDetails={userDetails} />

                    {myServers ? <HordeManager myServers={myServers} setMyServers={setMyServers} userDetails={userDetails} /> : <CircularProgress />}
                </Box>
                : <Typography>Please Log In First (top right) and Refresh</Typography>
            }
        </Box>
    )


}

function ChangeRCONPassDialog({ userData, server, isOpen, onClose }) {
    const classes = useStyles()

    const [newPass, setNewPass] = useState()
    const [isChanging, setIsChanging] = useState(false)
    const [changeResponse, setChangeResponse] = useState()

    const handleExecuteClick = () => {
        setIsChanging(true)
        const { user_name, user_detail, password } = userData
        const { ip, rconpass } = server

        //send api call
        api.changeRCONPassword(user_name, user_detail.email, password, ip, rconpass, newPass)
            .then(r => {
                // console.log(r)
                setIsChanging(false)
                setChangeResponse(r.message ? r.message : r)
            })
        // console.log(userData, server, newPass)
    }

    const handleNewPass = (event) => {
        setNewPass(event.target.value)
    }

    return (
        <Dialog

            open={isOpen}
            onClose={onClose}
        >
            <DialogTitle>Change RCON Password</DialogTitle>
            <DialogContent>
                <Typography>Server Name: {server.name}</Typography>
                <Typography>Server IP: {server.ip}</Typography>
                <Typography>Current Password: {server.rconpass}</Typography>
            </DialogContent>
            <DialogContent>
                <Typography>New Password:</Typography>
                <Input onChange={handleNewPass} />
            </DialogContent>

            <DialogActions className={classes.spaced}>
                {isChanging ? <CircularProgress /> :
                    <Button color='secondary' variant='contained' onClick={handleExecuteClick}>
                        Change Password
                    </Button>

                }
            </DialogActions>
            <Box className={classes.spaced}>
                <p>{changeResponse}</p>
            </Box>


        </Dialog>
    )
}

function HordeManager({ userDetails, myServers, setMyServers }) {
    const classes = useStyles();
    const [userData, setUserData] = useState(userDetails)
    const [settings, setSettings] = useState()
    const [alert, setAlert] = useState({ 'isOpen': false })
    const [update, setUpdate] = useState()
    const [isSaving, setIsSaving] = useState(false)
    const [isChangeRCONPass, setIsChangeRCONPass] = useState(false)
    const [selectedServer, setSelectedServer] = useState()

    const handleManage = async (serverip, rowi) => {
        const loadingServers = myServers.map((x, i) => i == rowi ? { ...x, 'isLoading': true, 'selected': true } : { ...x, 'selected': false, 'isError': false })
        setMyServers(loadingServers)
        try {
            const thisServerObj = myServers.find(s => s.ip == serverip)
            const thisSettings = await api.getSettings(thisServerObj.rconpass, serverip)
            const thisWebhook = await api.getWebhook(thisServerObj.rconpass, serverip)
            const successServers = myServers.map((x, i) => i == rowi ? { ...x, 'isLoading': false, 'selected': true } : { ...x, 'selected': false, 'isError': false })
            setMyServers(successServers)
            thisSettings.Maps = thisSettings.Maps.map(x => ({ GameMode: x.GameMode.replaceAll('"', ''), MapId: x.MapId.replaceAll('"', '') }))
            thisSettings.ServerName = thisSettings.ServerName.replaceAll('"', '')
            thisSettings.webhook = thisWebhook
          // console.log(thisSettings)
            setSettings(thisSettings)
        } catch (e) {
            console.log(e)
            const errorServers = myServers.map((x, i) => i == rowi ? { ...x, 'isLoading': false, 'selected': true, 'isError': true } : { ...x, 'selected': false, 'isError': false })
            setMyServers(errorServers)
            setSettings()
        }


    }

    const handleRconClick = (row, i) => {
        navigate("/rcon", {
            state: {
                server: row
            },
        })
    }

    const confirmSave = async (settingsObj, webhookStr) => {
        const selectedServer = myServers.find(x => x.selected)
        setAlert({ ...alert, 'isLoading': true })

        try {
            const gameiniSettings = { ...settingsObj }
            // if (gameiniSettings.webhook) delete gameiniSettings.webhook
            const setResponse = await api.setSettings(selectedServer.rconpass, selectedServer.ip, gameiniSettings)
            if (webhookStr) await api.setWebhook(selectedServer.rconpass, selectedServer.ip, webhookStr)
            const updateObj = {
                'status': setResponse.status,
                'message': setResponse.data.status
            }
          // console.log('Sent:', settingsObj, webhookStr)
            setUpdate(updateObj)
        } catch (setResponse) {
          // console.log(setResponse)
            try {
                const updateObj = {
                    'status': setResponse.status,
                    'message': setResponse.data.status
                }
              // console.log('Error:', settingsObj)
                setUpdate(updateObj)
            } catch (e) {
                setUpdate({ status: 'Error', message: 'error' })
            }
        }

        setIsSaving(false)
        setAlert({ isOpen: false })
        setSettings(settings)
    }

    const cancelSave = async () => {
      // console.log(`Cancelled!`)
        setAlert({
            'isOpen': false
        })
        setIsSaving(false)
    }

    const saveChanges = async (settingsObj, webhookStr) => {
        setIsSaving(true)
        const serverList = await api.getAllServers()
        const newServers = myServers.map(s => {
            const liveServer = serverList.find(x => x.ip == s.ip) || s
            const joinedServer = { ...s, ...liveServer }
            return joinedServer
        })
        setMyServers(newServers)


        const selectedServer = myServers.find(x => x.selected)
        const activePlayers = selectedServer && selectedServer.slots
        setAlert({
            'isOpen': true,
            'activePlayers': activePlayers,
            'onCancel': cancelSave,
            'onConfirm': () => confirmSave(settingsObj, webhookStr)
        })


    }

    const updateClose = () => {
        setUpdate()
    }

    const handleRCONPassChange = (server) => {
        setSelectedServer(server)
        setIsChangeRCONPass(true)
    }

    const handleRCONPassChangeClose = () => {
        setIsChangeRCONPass(false)
    }

    const handleHardReset = (server) => {
      // console.log(server, data)
    }

    useEffect(() => {
        const update = async () => {
            const serverList = await api.getAllServers()
            const newServers = myServers.map(s => {
                const liveServer = serverList.find(x => x.ip == s.ip) || s
                const joinedServer = { ...s, ...liveServer }
                return joinedServer
            })
            setMyServers(newServers)
        }
        update()
    }, [settings])

    return (
        <Box>
            {alert.isOpen && <AlertSure alertOptions={alert}></AlertSure>}
            {selectedServer &&
                isChangeRCONPass ?
                <ChangeRCONPassDialog isOpen={isChangeRCONPass} userData={userData} server={selectedServer} onClose={handleRCONPassChangeClose} /> :
                  <></>}


            <Box>
                {userData ?
                    <Box>
                        {myServers.length > 0 ? <ManageServersTable data={myServers} handleRconClick={handleRconClick} ></ManageServersTable> : <CircularProgress />}
                    </Box>
                    : <Login userDetails={userDetails} setUpdate={setUpdate} setUserData={setUserData}></Login>}
            </Box>
            <Box>
                {settings && <SettingsManager isSaving={isSaving} data={settings} saveChanges={saveChanges}></SettingsManager>}
            </Box>
            <Box>
                {update &&
                    <Snackbar
                        onClose={updateClose}
                        open={true}
                        autoHideDuration={2000}>
                        <SnackbarContent
                            className={update.status == 200 ? classes.alertSuccess : classes.alertError}
                            message={update.message}
                        />
                    </Snackbar>}
            </Box>
        </Box>
    )

}

function SettingsManager({ data, saveChanges, isSaving }) {

    return (
        <Box pt={3}>
            <Typography variant={"h4"}>{`Server Settings - ${data.ServerName}`} </Typography>
            <ServerSettingsTable isSaving={isSaving} data={data} saveChanges={saveChanges}></ServerSettingsTable>
        </Box>
    )
}

function Login({ setUpdate, setUserData, userDetails }) {

    const [pwd, setPwd] = useState(userDetails.password)
    const [username, setUName] = useState(userDetails.user_name)
    const [isLoading, setIsLoading] = useState(false)
    const [status, setStatus] = useState()

    const onSubmit = async (event) => {
        setIsLoading(true)
        try {
            const serverPerms = userDetails.user_perms
            const serverList = await api.getAllServers()
            const myServers = serverPerms.servers.map(s => serverList.find(x => x.ip == s.ip) || s)
            const myUserData = { 'perms': { ...serverPerms }, 'servers': myServers, 'login': { 'username': username, 'password': pwd } }
            setUserData(myUserData)
        } catch (e) {
            if (e.response) {
                const updateObj = {
                    'status': e.response.status,
                    'message': `Error: ${e.response.statusText}`
                }
                setUpdate(updateObj)
            } else {
                const updateObj = {
                    'status': 404,
                    'message': `Error`
                }
                setUpdate(updateObj)
            }
            setIsLoading(false)
        }

    }

    useEffect(() => {
        onSubmit()
    }, [])


    return (
        <Box>
            <form noValidate autoComplete="off" onSubmit={onSubmit}>
                <Box>
                    <Box pt={3} mx="auto" >
                        {isLoading ? <CircularProgress />
                            : <Button variant="contained" color="secondary" type="submit">Login</Button>
                        }<Box>{status}</Box>
                    </Box>
                </Box>
            </form>
        </Box>
    )
}

function Logout() {

    const handleLogout = () => {
        if (typeof window !== `undefined`) window.localStorage.clear()
        navigate("/")
    }

    return (
        <Box>
            <Button onClick={handleLogout} variant="contained" color="secondary">Log Out</Button>
        </Box>
    )
}

export default AccountManager